import { EnergyLabelQuestion } from '@hb/domain';
import { PropertyStoreService } from '@hb/modules/property/property-store.service';
import { getDefaultEnergyLabel } from '@hb/modules/global/global.constants';
import { AbstractStoreInjectOption } from '@hb/services/store/abstract-store-inject.service';

import { inject, Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, distinctUntilChanged } from 'rxjs';

import { EnergyLabel, PropertyType } from '@ap/ap-interface-apix-hypotheken-berekening';

@Injectable({
    providedIn: 'root'
})
export class EnergyLabelStoreService extends AbstractStoreInjectOption<EnergyLabelQuestion> implements OnDestroy {
    protected readonly store = inject(PropertyStoreService);
    protected readonly lastQuestion = EnergyLabelQuestion.SUMMARY;

    private readonly energyLabelSubject: BehaviorSubject<EnergyLabel>;

    constructor() {
        super();
        this.init();
        const initialValues = this.getInitialValues();
        this.energyLabelSubject = new BehaviorSubject<EnergyLabel>(initialValues);
        this.subscriptions();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this.activeQuestionSubject.unsubscribe();
        this.energyLabelSubject.unsubscribe();
    }

    getEnergyLabel(): Observable<EnergyLabel> {
        return this.energyLabelSubject.asObservable();
    }

    setEnergyLabel(energyLabel: EnergyLabel): void {
        this.energyLabelSubject.next(energyLabel);
    }

    getPropertyType(): Observable<PropertyType> {
        return this.store.getPropertyType();
    }

    getInitialValues(): EnergyLabel {
        return this.store.getPropertyState()?.energy_label;
    }

    update(): void {
        this.store.setEnergyLabel(this.energyLabelSubject.value);
    }

    private subscriptions(): void {
        this.store
            .getPropertyType()
            .pipe(distinctUntilChanged())
            .subscribe((propertyType: PropertyType) => {
                if (this.store.getPropertyState()?.property_type !== propertyType) {
                    this.setEnergyLabel(getDefaultEnergyLabel(propertyType));
                }
            });

        this.energyLabelSubject.asObservable().subscribe(() => {
            this.update();
        });
    }
}
